import { gql } from '@apollo/client';

const REQUEST_INVITATION = gql`
	mutation RequestInvitation($input: RequestInvitationInput!) {
		requestInvitation(input: $input)
	}
`;

const GET_ALL_PROMOS = gql`
	query GetAllPromos {
		getPromotions {
			priority
			national
			option1
			disclaimer1
			conjunction1
			option2
			disclaimer2
			conjunction2
			option3
			disclaimer3
			name
			hideNameOnClient
		}
	}
`;

const GET_PROMOS_BY_BRANCH = gql`
	query GetPromosByID($branchIDs: String!) {
		getPromotionsByBranchId(branchId: $branchIDs) {
			priority
			national
			option1
			disclaimer1
			conjunction1
			option2
			disclaimer2
			conjunction2
			option3
			disclaimer3
			name
			hideNameOnClient
			endDate
			startDate
		}
	}
`;

const GET_APPOINTMENT_CALENDAR = gql`
	query GetAppointmentCalendar($input: AppointmentCalendarInput!) {
		getAppointmentCalendar(input: $input) {
			resourceId
			timezoneCode
			timezoneShortCode
			timeslots {
				startDateTime
				endDateTime
			}
		}
	}
`;

const CREATE_APPOINTMENT = gql`
	mutation CreateAppointment($input: CreateAppointmentInput!) {
		createAppointment(input: $input) {
			customerDetails
			email
			endDate
			firstName
			phoneNumber
			postalCode
			resourceId
			startDate
			timezoneCode
			timezoneShortCode
		}
	}
`;

const MY_APPOINTMENTS = gql`
	query MyAppointments {
		myAppointments {
			id
		}
	}
`;

const SUBMIT_EXIT_INTENT = gql`
	mutation SubmitExitIntentForm($input: CreateExitIntentFormInput!) {
		submitExitIntentForm(input: $input) {
			id
		}
	}
`;

const SUBMIT_PRE_RTA_FORM = gql`
	mutation SubmitPreRtaForm($input: CreatePreRtaFormInput!) {
		submitPreRtaForm(input: $input) {
			id
		}
	}
`;

const SUBMIT_CCPA_FORM = gql`
	mutation SubmitCCPAForm($input: CreateCCPAFormInput!) {
		submitCCPAForm(input: $input) {
			id
		}
	}
`;

const SUBMIT_WEB_CONTACT_FORM = gql`
	mutation SubmitWebContactUsForm($input: CreateWebContactUsFormInput!) {
		submitWebContactUsForm(input: $input) {
			id
		}
	}
`;

export { CREATE_APPOINTMENT, REQUEST_INVITATION, GET_ALL_PROMOS, GET_PROMOS_BY_BRANCH, GET_APPOINTMENT_CALENDAR, MY_APPOINTMENTS, SUBMIT_EXIT_INTENT, SUBMIT_PRE_RTA_FORM, SUBMIT_CCPA_FORM, SUBMIT_WEB_CONTACT_FORM };
